<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/yongxin/equipment/openCloseMouldCount" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select multiple type="equipment" :placeholder="$t('suoyoushebei')" :ids.sync="yt.conditions.equipmentIds"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shebeileixing')">
            <yi_dictionary_select :type="'EQUIPMENT_TYPES'" :ids.sync="yt.conditions.typeId" disabled="true"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')">
            <yi_data_select :type="'organization'" :idsPath.sync="yt.conditions.orgId" :ids.sync="yt.conditions.selecteOrgId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('tongjishijian')">
            <yi_time_input format="yyyy-MM-dd HH:mm:ss" value-format="timestamp" type="datetimerange" :start.sync="yt.conditions.startTime" :end.sync="yt.conditions.endTime" :maxTime="60 * 24 * 3600 * 1000"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="reset">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL> </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
import dayjs from 'dayjs';
// 获取当月 1 号 0 点的时间戳
const startOfMonth = dayjs()
  .startOf('day')
  .valueOf();
// 获取当月月末 23 点 59 分 59 秒的时间戳
const endOfMonth = dayjs()
  .endOf('day')
  .valueOf();

export default {
  name: 'web_customize_yongxin_equipment_open_close_mould_report_list',
  data() {
    return {
      conditions: {
        startTime: startOfMonth,
        endTime: endOfMonth,
        typeId: '1'
      },
      columns: [
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name'
        },
        {
          label: 'suoshuzuzhi',
          prop: 'org.name'
        },
        {
          label: 'tongjikaishishijian',
          prop: 'startTime',
          type: 'time'
        },
        {
          label: 'tongjijieshushijian',
          prop: 'endTime',
          type: 'time'
        },
        {
          label: 'shebeikaishimucishu',
          prop: 'startMouldCount'
        },
        {
          label: 'shebeijieshumucishu',
          prop: 'endMouldCount'
        },
        {
          label: 'kaihemocishu',
          prop: 'openCloseMouldCount'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = this.utils.copy(this.conditions);
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 重置
    reset() {
      this.yt.clear(this.conditions);
    }
  }
};
</script>
